import { IconButton, Stack, TextField, Tooltip } from "@mui/material"
import SearchIcon from "@mui/icons-material/Search"
import { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom";

export default function ToolbarActionsSearch() {
  const [search, setSearch] = useState("");
  const navigate = useNavigate();
  const { panno } = useParams();

  const handleChange = (e) => {
    const value = e.target.value.toUpperCase();

    const firstPartValid = /^[A-Za-z]{0,5}$/.test(value.slice(0, 5));

    const secondPartValid = /^[0-9]{0,4}$/.test(value.slice(5, 9));

    const lastPartValid = /^[A-Za-z]{0,1}$/.test(value.slice(9, 10));

    if (value.length <= 10 && firstPartValid && secondPartValid && lastPartValid) {
      setSearch(value);
    }
  };

  const handleKeyDown = (e) => {
    if (e?.key === "Enter" && search?.length === 10) {
      navigate(`/panlookup/${search}`);
    }
  };

  useEffect(() => {
    if (panno) {
      setSearch(panno); 
    }
  }, [panno]);

  return (
    <Stack direction="row">
      <TextField
        label="Enter PAN No."
        variant="outlined"
        size="small"
        value={search}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        slotProps={{
          input: {
            endAdornment: (
              <IconButton type="button" aria-label="search" size="small">
                <SearchIcon />
              </IconButton>
            ),
            sx: { pr: 0.5 }
          }
        }}
        sx={{
          width: {
            xs: "110px",   
            sm: "220px",  
            md: "auto"    
          },
          mr: 1
        }}
        autoComplete="off"
      />
    </Stack>
  )
}
